import React, { useState } from 'react';
import axios from 'axios';

const ReviewerRegistrationEdit = () => {
    const API = process.env.REACT_APP_API_BASE_URL;
    const [formData, setFormData] = useState({
        ReviewerID: '',
        UserName: '',
        Password: '',
        ReviewerName: '',
        Address: '',
        EmailID: '',
        ContactNumber: '',
        IsAgree: false,
        IsApproved: 2,
        PlatformID: ''
    });

    const [agreementFile, setAgreementFile] = useState(null);
    const [Profile, setProfile] = useState(null);
    const [oldUserName, setOldUserName] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (name === 'AgreementFile') setAgreementFile(files[0]);
        if (name === 'Profile') setProfile(files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await axios.post(`${API}/api/reviewer/get-reviewer`, {
                UserName: oldUserName,
                Password: formData.Password
            });

            setFormData({
                ReviewerID: res.data.ReviewerID,
                UserName: res.data.UserName,
                Password: '',
                ReviewerName: res.data.ReviewerName,
                Address: res.data.Address,
                EmailID: res.data.EmailID,
                ContactNumber: res.data.ContactNumber,
                IsAgree: res.data.IsAgree === 1,
                IsApproved: res.data.IsApproved,
                PlatformID: res.data.PlatformID
            });

        } catch (error) {
            alert(error.response?.data?.message || 'Error fetching reviewer');
        }
    };

    const handleEdit = async (e) => {
        e.preventDefault();

        const formPayload = new FormData();

        for (const key in formData) {
            formPayload.append(key, formData[key]);
        }

        formPayload.append('OldUserName', oldUserName);

        if (agreementFile) {
            formPayload.append('AgreementFile', agreementFile);
        }

        if (Profile) {
            formPayload.append('Profile', Profile);
        }

        try {
            const res = await axios.post(`${API}/api/reviewer/update-reviewer`, formPayload, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            alert(res.data.message);
            setFormData({
                ReviewerID: '',
                UserName: '',
                Password: '',
                ReviewerName: '',
                Address: '',
                EmailID: '',
                ContactNumber: '',
                IsAgree: false,
                IsApproved: 2,
                PlatformID: ''
            });
            setOldUserName('');
            setAgreementFile(null);
            setProfile(null);
        } catch (error) {
            alert(error.response?.data?.message || 'Error updating reviewer');
        }
    };

    return (
        <div className="container mt-5 mb-5 d-flex justify-content-center">
            <div className="card p-4 shadow-sm w-100" style={{ maxWidth: '700px' }}>
                <h3 className="text-center page-title mb-4">Enter Reviewer Credentials</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                        <label className="form-label fw-semibold">User Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={oldUserName}
                            onChange={(e) => setOldUserName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label className="form-label fw-semibold">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            value={formData.Password}
                            onChange={(e) => setFormData({ ...formData, Password: e.target.value })}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100">Get Data</button>
                </form>

                <h3 className="text-center page-title mb-4 mt-4">Edit Reviewer Details</h3>
                <form onSubmit={handleEdit} encType="multipart/form-data">
                    {/* <div className="form-group mb-3">
                        <label className="form-label fw-semibold">Reviewer ID</label>
                        <input
                            type="text"
                            className="form-control"
                            value={formData.ReviewerID}
                            disabled
                            readOnly
                        />
                    </div> */}
                    <div className="form-group mb-3">
                        <label className="form-label fw-semibold">User Name</label>
                        <input
                            type="text"
                            name="UserName"
                            className="form-control"
                            value={formData.UserName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label className="form-label fw-semibold">Reviewer Name</label>
                        <input
                            type="text"
                            name="ReviewerName"
                            className="form-control"
                            value={formData.ReviewerName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label className="form-label fw-semibold">Address</label>
                        <textarea
                            name="Address"
                            className="form-control"
                            rows={3}
                            value={formData.Address}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label className="form-label fw-semibold">Email</label>
                        <input
                            type="email"
                            name="EmailID"
                            className="form-control"
                            value={formData.EmailID}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label className="form-label fw-semibold">Contact Number</label>
                        <input
                            type="text"
                            name="ContactNumber"
                            className="form-control"
                            value={formData.ContactNumber}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label className="form-label fw-semibold">Agreement File</label>
                        <input
                            type="file"
                            name="AgreementFile"
                            className="form-control"
                            onChange={handleFileChange}
                            accept="application/pdf"
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label className="form-label fw-semibold">Profile</label>
                        <input
                            type="file"
                            name="Profile"
                            className="form-control"
                            onChange={handleFileChange}
                            accept="application/pdf"
                        />
                    </div>
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsAgree"
                            id="IsAgree"
                            checked={formData.IsAgree}
                            onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="IsAgree">
                            I agree to the terms and conditions
                        </label>
                    </div>
                    {/* <div className="form-group mb-3">
                        <label className="form-label fw-semibold">Platform ID</label>
                        <input
                            type="text"
                            name="PlatformID"
                            className="form-control"
                            value={formData.PlatformID}
                            onChange={handleChange}
                            required
                        />
                    </div> */}
                    <button type="submit" className="btn btn-primary w-100">Update Reviewer</button>
                </form>
            </div>
        </div>
    );
};

export default ReviewerRegistrationEdit;
